const { createActionTypeModel } = require("../../../../store/global/action-model");

export const TasksData = createActionTypeModel('TasksData');
export const TasksList = createActionTypeModel('TasksList');
export const TasksDetails = createActionTypeModel('TasksDetails');